import * as i from 'types';

export const classesDataSelector = (state: i.ReduxState) => state.series?.data?.classes;
export const starterClassesDataSelector = (state: i.ReduxState) => state.series?.data?.starters[0];
export const membershipDataSelector = (state: i.ReduxState) => state.series?.data?.subscriptions;
